<template>
    <UApp>
        <AppHeader v-if="loginStore.hasAccess" />
        <div
            v-if="loginStore.hasAccess"
            class="w-full flex justify-end px-10 pb-3"
        >
            <InsertModal type="insert" />
            <UButton
                v-if="loginStore.hasAccess"
                icon="prime:download"
                color="neutral"
                size="md"
                variant="ghost"
                class="font-promedium text-black-text cursor-pointer rounded-none hover:bg-black-text hover:text-white transition-none"
                @click="store.exportData"
            >
                Export dat
            </UButton>
            <div
                class="flex gap-3 item-center justify-end px-2 text-sm font-promedium"
            >
                <UButton
                    v-if="loginStore.hasAccess"
                    icon="prime:sign-out"
                    color="neutral"
                    size="md"
                    variant="ghost"
                    class="font-promedium text-black-text cursor-pointer rounded-none hover:bg-black-text hover:text-white transition-none"
                    @click="loginStore.logout"
                >
                    Odhlásit
                </UButton>
            </div>
        </div>
        <div
            v-if="loginStore.hasAccess"
            class="px-4"
        >
            <TablesMainTable
                :data="store.tableData"
                type="full"
            />
        </div>
        <div v-if="loginStore.logged && !loginStore.hasAccess">
            <div class="flex items-center justify-center h-screen">
                <div class="flex flex-col gap-3 items-center text-center">
                    <h1 class="text-2xl font-promedium">
                        Do aplikace nemáte přístup
                    </h1>
                    <UButton
                        label="Zpět na přihlášení"
                        color="neutral"
                        class="w-max font-promedium cursor-pointer"
                        @click="loginStore.logout"
                    />
                </div>
            </div>
        </div>
    </UApp>
</template>
<script setup lang="ts">
const store = useMainStore()
const loginStore = useLoginStore()

useHead({
    title: "Evidence okrskářů Městské policie",
})

onMounted(async () => {
    if (!loginStore.logged) {
        await loginStore.login()
    }
    await store.fetchTable()
})
</script>
<style></style>
